import * as React from 'react';

import './InterestPage.css';

class InterestPage extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div className="verticalStretchWrapper">
                <div className="LoginPage">
                  Thanks for your interest in Kwerk! (User not authorized)
                </div>
            </div>
        );
    }

    public componentDidMount() {
      return true;
    }

}

export default InterestPage;



// WEBPACK FOOTER //
// ./src/InterestPage.tsx